import React from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export type MappingStatusFilter = 'Pending' | 'Approved' | 'Rejected' | '';

const OPTIONS: Array<{ value: MappingStatusFilter; label: string }> = [
  { value: '', label: 'Pending (default)' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
];

interface Props {
  value: MappingStatusFilter;
  onChange: (newValue: MappingStatusFilter) => void;
}

export default function AccommodationMappingStatusFilterInput({ value, onChange }: Props) {
  return (
    <FormControl fullWidth>
      <InputLabel shrink>Mapping status</InputLabel>
      <Select<MappingStatusFilter>
        value={value}
        label="Mapping status"
        displayEmpty
        notched
        onChange={(e) => onChange(e.target.value)}
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option.value || 'pending'} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
